import type { EdgeId } from '@ipfabric/utils';
import { unhighlightEdge } from 'components/Graph/commands/edges/unhighlightEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface UnhighlightEdgesCommand {
  color?: boolean;
  edges: EdgeId[];
  thickness?: boolean;
}

export const unhighlightEdges: GraphCommandFactory<UnhighlightEdgesCommand> =
  (_cmdContext, dispatch) => (command) => {
    for (const edgeId of command.edges) {
      dispatch(unhighlightEdge, {
        color: command.color,
        edgeId,
        thickness: command.thickness,
      });
    }
  };
